<template>
  <div class="pc-interest">

    <h1 class="pc-interest-head">偏好信息</h1>
    <div class="pc-interest-body">
      <div class="body-left">
        <div>
          <h1>{{ data[0].title }}&nbsp;</h1>
          <p>{{ data[0].value ? data[0].value : '- -' }}</p>
        </div>
        <div>
          <h1>{{ data[2].title }}&nbsp;</h1>
          <p>{{ data[2].value ? data[2].value : '- -' }}</p>
        </div>
        <div>
          <h1>{{ data[4].title }}&nbsp;</h1>
          <p>{{ data[4].value ? data[4].value : '- -' }}</p>
        </div>
      </div>
      <div class="body-right">
        <div>
          <h1>{{ data[1].title }}&nbsp;</h1>
          <p>{{ data[1].value ? data[1].value : '- -' }}</p>
        </div>
        <div>
          <h1>{{ data[3].title }}&nbsp;</h1>
          <p>{{ data[3].value ? data[3].value : '- -' }}</p>
        </div>
        <div>
          <h1>{{ data[5].title }}&nbsp;</h1>
          <p>{{ data[5].value ? data[5].value : '- -' }}</p>
        </div>
      </div>
    </div>

  </div>
</template>



<script>
export default {
  props: { userPortrait: Object },
  watch:{
    userPortrait: function () {
      let _hobby = this.userPortrait.preference;

      this.data[0].value = this.arrayToString(_hobby.course);
      this.data[1].value = this.arrayToString(_hobby.scholar);
      this.data[2].value = this.arrayToString(_hobby.job);
      this.data[3].value = this.arrayToString(_hobby.university);
      this.data[4].value = this.arrayToString(_hobby.news);
      this.data[5].value = this.arrayToString(_hobby.module);
    }
  },
  data() {
    return {
      data: [
        {title: '课程偏好: ', value: null}, 
        {title: '学者偏好: ', value: null}, 
        {title: '岗位偏好: ', value: null}, 
        {title: '院校偏好: ', value: null}, 
        {title: '新闻偏好: ', value: null}, 
        {title: '板块偏好: ', value: null}, 
      ],
    }
  },
  methods: {
    arrayToString ( array ) {
      if ( !array ) {
        return
      }
      let _arr = []
      array.forEach(item => {
        _arr.push( item.name )
      });
      _arr = _arr.join(',');
      return _arr
    }
  }
}
</script>



<style lang="scss" scoped>
.pc-interest {
  padding: 30px 30px 0 30px;
  height: 270px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-interest-head {
    padding-bottom: 15px;
    border-bottom: 1px solid $border-color;
    font-family: $chinese;
    font-size: 20px;
    font-weight: 600;
    color: $mainTitle;
  }

  // 滚轴
  .pc-interest-body::-webkit-scrollbar-thumb {
    background-clip: content-box !important;
    border-left: 2px solid transparent;
    border-right: 2.5px solid transparent;
    border-top: 2px solid transparent;
    border-bottom: 2.5px solid transparent;
    border-radius: 100px;
    background-color: $lightenGreya;
  }
  .pc-interest-body::-webkit-scrollbar-button {
    display: none;
  }
  .pc-interest-body::-webkit-scrollbar {
    height: 12px;
    border: $bordertabled;
  }
  // end 滚轴
  .pc-interest-body {
    margin-top: 35px;
    margin-left: 10px;
    overflow-y: auto;
    overflow-x: unset;
    height: 140px;
    display: flex;
    // .body-right {
    //   margin-left: 50px;
    // }
    .body-left,
    .body-right {
      div {
        display: flex;
        margin-bottom: 25px;
        h1, p {
          font-family: $chinese;
          font-size: 14px;
          font-weight: 400;
          color: $mainTitle;
          white-space: nowrap;
        }
        h1 {
          font-weight: bold;
        }
        p {
          min-width: 100px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/UserInterest.vue